import theme from '@styles/theme';
export default {
  productCard: (isSlider = false) => ({
    width: '100%',
    height: isSlider ? '100%' : 'auto',
    display: isSlider ? 'flex' : 'block',
    flexDirection: isSlider ? 'column' : undefined,
    textDecoration: 'none',
    position: 'relative',
    '&:hover .hoverImage': {
      opacity: 1
    },
    '&:hover .bottom_labels span': {
      transform: 'translateY(-10px)'
    },
    '&.product-card-has-hover:hover .product-config-button span': {
      borderColor: theme.rawColors.neutralWhite,
      transition: 'border-color 0.2s ease'
    },
    '&.product-card-has-hover:hover .product-config-button p': {
      color: theme.rawColors.neutralWhite,
      transition: 'color 0.2s ease'
    },
    '&.product-card-has-hover:hover .product-config-button svg path, &.product-card-has-hover:hover .product-config-button svg rect': {
      fill: theme.rawColors.neutralWhite,
      transition: 'fill 0.2s ease'
    }
  }),
  productCardInner: (isSlider = false) => ({
    width: '100%',
    height: '100%',
    ...(isSlider ? {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    } : {})
  }),
  visualArea: (transparent = false, isWhiteBg = false) => ({
    bg: transparent ? 'transparent' : isWhiteBg ? theme.rawColors.neutralWhite : theme.rawColors.lightGreyBgProduct,
    position: 'relative'
  }),
  imageLink: {
    display: 'block',
    width: '100%',
    height: '100%',
    outline: 'none',
    '&:focus-visible': {
      outline: `2px solid ${theme.rawColors.blue500}`,
      outlineOffset: '2px'
    }
  }
};